const projects = [
    {
        title: "Disaster Management",
        image: `https://github.com/user-attachments/assets/bd5f8855-bab9-4b1e-b88a-924c2cdac7db`,
        description: "This website informs what are the steps small scale business should take before, during and after the diaster",
        link: "https://beforeduringafter.txst.edu/",
        source: "https://beforeduringafter.txst.edu/",
    },
    {
        title: "E-commerce Clothing Application",
        image: `https://user-images.githubusercontent.com/29236686/162415844-82332478-77d4-4b44-ae7d-f7b9ff49abb2.svg`,
        description: "It's an e-commerce application for apparel. We can view different sections and items and can add them to the cart. Added a payment option after checking out the items.",
        link: "https://g3vkvm.csb.app/",
        source: "https://github.com/Harsha70/Ecommerce_app",
    },
    {
        title: "Expense Tracker",
        image: `https://github.com/Harsha70/personal-portfolio/assets/29236686/48b1a940-f05d-43b8-bddd-8fd9b0052e65`,
        description: "",
        link: "https://expense-tracker-1-6h9w.onrender.com/login",
        source: "https://github.com/Harsha70/Expense-tracker",
    },
    {
        title: "Nature Tour Application",
        image: `https://github.com/Harsha70/NatureTour/assets/29236686/7bc32753-00a6-4717-9033-37e56b874436`,
        description: "It shows the list of tours available on the website and we can see the details of the tour",
        link: "https://naturetour.onrender.com/",
        source: "https://github.com/Harsha70/NatureTour",
    },
    {
        title: "Dine Finder",
        image: `https://github.com/Harsha70/personal-portfolio/assets/29236686/859eff2e-b0b6-4e43-8526-2a6402de9669`,
        description: "This mobile application assists users in discovering restaurants in a specific city. It allows users to view the menu items available at each restaurant and place orders directly through the app.",
        link: "https://www.youtube.com/watch?v=0ct6e08oqIo",
        source: "https://github.com/Harsha70/find_a_restaurant",
    },
    {
        title: "Movie App",
        image: `https://user-images.githubusercontent.com/29236686/162419160-198a94d6-88ae-460e-b2a5-0e05c71cc997.svg`,
        description: "It's a Movie application based on the public movie apis. We can bookmark a movie to watch it later",
        link: "https://movie-app123.netlify.app/",
        source: "https://github.com/Harsha70/Movieapp",
    },
    {
        title: "Travel Plan",
        image: `https://github-production-user-asset-6210df.s3.amazonaws.com/29236686/262477384-204d0822-5f17-4169-abdf-19a41304f1e1.svg`,
        description: "This application keeps track of the items that we need for travelling.",
        link: "https://stackblitz-starters-unkwzp.stackblitz.io",
        source:"https://stackblitz.com/edit/stackblitz-starters-unkwzp?file=src%2Findex.js",
    },
    {
        title: "Robo Friends",
        image: `https://github-production-user-asset-6210df.s3.amazonaws.com/29236686/262483448-456d766b-0a06-4cbb-a211-b6dffbf44acb.svg`,
        description: "Created a small funny web-application with name filter functionality. A good demonstration of the component and state usage inside ReactJS.",
        link: "https://harsha70.github.io/RobotBuddies/",
        source:"https://github.com/Harsha70/RobotBuddies",
    },
    {
        title: "Flickgram",
        image: `https://user-images.githubusercontent.com/29236686/162423174-d7d69204-b444-41ef-bdfb-7cc782535a89.svg`,
        description: "It a photo sharing application. Initially people have to sign in with google authentication and upload their photos and like other photos. But can only delete their own photos. Firebase is used to store images in the backend",
        link: "https://flickgram.netlify.app/",
        source: "https://github.com/Harsha70/Flickgram",
    },
    {
        title: "Chat Application",
        image: `https://user-images.githubusercontent.com/29236686/162422873-fdf62fda-1fea-46bd-b52a-f43f0130db8d.svg`,
        description: "Its a simple chat-application. it has google authentication to sign in. We can add new groups and edit messages and upload images in the chat.",
        link: "https://public-group-chat.netlify.app/",
        source: "https://github.com/Harsha70/Chatapplication",
    }, 
    {
        title: "Event-Calendar",
        image: `https://user-images.githubusercontent.com/29236686/162422716-d6fe4a2a-2749-4d92-a935-6f3bece26180.svg`,
        description: "It is a Calendar build with google calendar api. We can add, edit and delete the event from the calendar",
        link: "https://github.com/Harsha70/InventamTechCalendar",
        source: "https://github.com/Harsha70/InventamTechCalendar",
    },
    {
        title: "Notes",
        image: `https://user-images.githubusercontent.com/29236686/162422784-9035291f-a75a-4d43-9b7a-37817db9b58e.svg`,
        description: "It is a note making application with text editor. Firebase is used for storing respective new text notes",
        link: "https://github.com/Harsha70/EverNote",
        source: "https://github.com/Harsha70/EverNote",
    },
]

export default projects;
